import React, { createContext, useContext } from 'react';
export const RIPPLE_COLOR_WHITE = [1, 1, 1];
export const RIPPLE_COLOR_YELLOW = [130 / 255, 85 / 255, 3 / 255];
export const ComputerVoiceCtx = createContext({
    isVoiceActive: false,
    toggleVoice: () => { },
    handleMuteClick: () => { },
    handleVoiceLockClick: () => { },
    handleSubmitClick: () => { },
    voiceAssistantTranscript: '',
    connectionState: 'idle',
    thinkingStatus: 'idle',
    isVoiceLocked: false,
    rippleTrigger: 0,
    rippleColor: RIPPLE_COLOR_YELLOW,
});
export function useComputerVoice() {
    return useContext(ComputerVoiceCtx);
}
//# sourceMappingURL=ComputerVoiceStateContextShared.js.map